var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.12499 8.80125L1.3779 6.05416C1.06915 5.74542 0.570403 5.74542 0.261653 6.05416C-0.0470972 6.36292 -0.0470972 6.86166 0.261653 7.17041L3.57082 10.4796C3.87957 10.7883 4.37832 10.7883 4.68707 10.4796L13.0629 2.10375C13.3717 1.795 13.3717 1.29625 13.0629 0.987498C12.7542 0.678748 12.2554 0.678748 11.9467 0.987498L4.12499 8.80125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.f2810d1f408cd22dff70ac4e557d7a89.svg";
export { ForwardRef as ReactComponent };